<app-back-button></app-back-button>
<div class="contents">
  <!-- ════ PAGE HEADER ════ -->
  <div class="page-header">
    <div>
      <h1 class="page-header-title">Gestão de Utilizadores</h1>
      <p class="page-header-sub">Veja, consulte perfis e gerencie os utilizadores da plataforma</p>
    </div>

    <div class="page-header-actions" *ngIf="stats">
      <div class="header-stat-pill">
        <i class="fas fa-users text-primary"></i>
        <span>Total: <strong>{{ stats.totalUtilizadores }}</strong></span>
      </div>
    </div>
  </div>

  <!-- Estatísticas de Utilizadores -->
  <div class="user-stats-container mb-4" *ngIf="stats">
    <div class="stats-card">
      <div class="stats-badge success">
        <i class="fas fa-check-circle"></i>
      </div>
      <div class="stats-info">
        <span class="stats-label">Ativos</span>
        <span class="stats-value">{{ stats.ativos }}</span>
      </div>
    </div>

    <div class="stats-card">
      <div class="stats-badge danger">
        <i class="fas fa-times-circle"></i>
      </div>
      <div class="stats-info">
        <span class="stats-label">Inativos</span>
        <span class="stats-value">{{ stats.inativos }}</span>
      </div>
    </div>

    <div class="stats-card">
      <div class="stats-badge info">
        <i class="fas fa-map-marker-alt"></i>
      </div>
      <div class="stats-info">
        <span class="stats-label">Nacionais</span>
        <span class="stats-value">{{ stats.nacional }}</span>
      </div>
    </div>

    <div class="stats-card">
      <div class="stats-badge purple">
        <i class="fas fa-globe"></i>
      </div>
      <div class="stats-info">
        <span class="stats-label">Estrangeiros</span>
        <span class="stats-value">{{ stats.estrangeiro }}</span>
      </div>
    </div>

    <div class="stats-card">
      <div class="stats-badge gray">
        <i class="fas fa-user-secret"></i>
      </div>
      <div class="stats-info">
        <span class="stats-label">Anónimos</span>
        <span class="stats-value">{{ stats.anonimos }}</span>
      </div>
    </div>

    <div class="stats-card">
      <div class="stats-badge primary">
        <i class="fas fa-id-card"></i>
      </div>
      <div class="stats-info">
        <span class="stats-label">Identificados</span>
        <span class="stats-value">{{ stats.naoAnonimos }}</span>
      </div>
    </div>
  </div>

  <app-lista-utilizadores></app-lista-utilizadores>
</div>